import { GenericService } from '@/services/api/generic.service';
import { SurveyResultChart } from '@/custom/menicon/models';

export class ExpertModeRequestSurveyResultChartsService extends GenericService<SurveyResultChart> {
  constructor(requestId: string) {
    super(`menicon/v1/expert-mode/encounter-requested-advices/${requestId}/survey-result-charts`);
  }
}
